import { FC } from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom'
import MainLayout from './layout/main-layout'
import ProfilePage from './pages/profile'
import { PrivateRouteWrapper } from './private-route-wrapper'
import { SettingsPage } from './pages/settings'
import { DefaultPage } from './pages/defaults'
import { OrganizationContactProvider } from './hooks/use-orgazination-contact'
import { ClientProvider } from './pages/create-forms/client-provider'
import CreateForms from './pages/create-forms'
import { AgreementPage } from './pages/agreements'

export const dashboardRoute = () => {
  return (
    <Route path="">
      <Route
        element={
          <PrivateRouteWrapper>
            <OrganizationContactProvider>
              <MainLayout />
            </OrganizationContactProvider>
          </PrivateRouteWrapper>
        }
      >
        <Route index element={<Navigate to={'agreement'} />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="agreement">
          <Route index element={<AgreementPage />} />
        </Route>
        <Route path="setting" element={<SettingsPage />} />
        <Route path="default" element={<DefaultPage />} />
      </Route>
      <Route
        element={
          <PrivateRouteWrapper>
            <OrganizationContactProvider>
              <Outlet />
            </OrganizationContactProvider>
          </PrivateRouteWrapper>
        }
      >
        <Route path="agreement/:documentId" Component={ClientProvider} errorElement={<Navigate to={'not-found'} />}>
          <Route path="create" Component={CreateForms}>
            <Route path=":sectionId" Component={CreateForms} />
          </Route>
        </Route>
      </Route>
    </Route>
  )
}

export const MainRouter: FC = () => {
  const router = createBrowserRouter(createRoutesFromElements(dashboardRoute()))
  return <RouterProvider router={router} />
}
